import { normalizeCrmSharePageSettings } from '../../shared/crm-share-page.js'
import type {
  CrmAdvancedFaqItem,
  CrmAdvancedFlowContent,
  CrmAdvancedFlowType,
  CrmAdvancedIconKey,
  CrmAdvancedMenuLink,
  CrmAdvancedOverlayMode,
  CrmAdvancedSiteSettings,
  CrmAdvancedWhyItem,
  CrmOrderMatchPlatform,
  CrmServicePageType,
} from '@/types/crm'

/** 高级版预设背景槽位（共 10 个；图片素材待补充时 imageUrl 为空，空槽位在前台回退到模板背景） */
export const CRM_ADVANCED_BACKGROUND_SLOTS: Array<{
  key: string
  label: string
  imageUrl: string
  thumbnailUrl: string
}> = [
  { key: 'bg1', label: '温馨家庭', imageUrl: '/images/website-bg/01.webp', thumbnailUrl: '/images/website-bg/thumbs/01.webp' },
  { key: 'bg2', label: '爱宠陪伴', imageUrl: '/images/website-bg/02.webp', thumbnailUrl: '/images/website-bg/thumbs/02.webp' },
  { key: 'bg3', label: '惬意时光', imageUrl: '/images/website-bg/03.webp', thumbnailUrl: '/images/website-bg/thumbs/03.webp' },
  { key: 'bg4', label: '长者生活', imageUrl: '/images/website-bg/04.webp', thumbnailUrl: '/images/website-bg/thumbs/04.webp' },
  { key: 'bg5', label: '居家办公', imageUrl: '/images/website-bg/05.webp', thumbnailUrl: '/images/website-bg/thumbs/05.webp' },
  { key: 'bg6', label: '专注工作', imageUrl: '/images/website-bg/06.webp', thumbnailUrl: '/images/website-bg/thumbs/06.webp' },
  { key: 'bg7', label: '海边漫步', imageUrl: '/images/website-bg/07.webp', thumbnailUrl: '/images/website-bg/thumbs/07.webp' },
  { key: 'bg8', label: '海边相伴', imageUrl: '/images/website-bg/08.webp', thumbnailUrl: '/images/website-bg/thumbs/08.webp' },
  { key: 'bg9', label: '贴心客服', imageUrl: '/images/website-bg/09.webp', thumbnailUrl: '/images/website-bg/thumbs/09.webp' },
  { key: 'bg10', label: '宁静午后', imageUrl: '/images/website-bg/10.webp', thumbnailUrl: '/images/website-bg/thumbs/10.webp' },
  { key: 'bg11', label: '音频美学', imageUrl: '/images/website-bg/11.webp', thumbnailUrl: '/images/website-bg/thumbs/11.webp' },
  { key: 'bg12', label: '未来科技', imageUrl: '/images/website-bg/12.webp', thumbnailUrl: '/images/website-bg/thumbs/12.webp' },
  { key: 'bg13', label: '山谷日落', imageUrl: '/images/website-bg/13.webp', thumbnailUrl: '/images/website-bg/thumbs/13.webp' },
  { key: 'bg14', label: '沉浸聆听', imageUrl: '/images/website-bg/14.webp', thumbnailUrl: '/images/website-bg/thumbs/14.webp' },
  { key: 'bg15', label: '海景庭院', imageUrl: '/images/website-bg/15.webp', thumbnailUrl: '/images/website-bg/thumbs/15.webp' },
  { key: 'bg16', label: '晨光客厅', imageUrl: '/images/website-bg/16.webp', thumbnailUrl: '/images/website-bg/thumbs/16.webp' },
  { key: 'bg17', label: '高山湖泊', imageUrl: '/images/website-bg/17.webp', thumbnailUrl: '/images/website-bg/thumbs/17.webp' },
  { key: 'bg18', label: '海岸微笑', imageUrl: '/images/website-bg/18.webp', thumbnailUrl: '/images/website-bg/thumbs/18.webp' },
  { key: 'bg19', label: '日照雪峰', imageUrl: '/images/website-bg/19.webp', thumbnailUrl: '/images/website-bg/thumbs/19.webp' },
  { key: 'bg20', label: '海边微风', imageUrl: '/images/website-bg/20.webp', thumbnailUrl: '/images/website-bg/thumbs/20.webp' },
  { key: 'bg21', label: '晴日微笑', imageUrl: '/images/website-bg/21.webp', thumbnailUrl: '/images/website-bg/thumbs/21.webp' },
  { key: 'bg22', label: '精选背景 22', imageUrl: '/images/website-bg/22.webp', thumbnailUrl: '/images/website-bg/thumbs/22.webp' },
  { key: 'bg23', label: '精选背景 23', imageUrl: '/images/website-bg/23.webp', thumbnailUrl: '/images/website-bg/thumbs/23.webp' },
  { key: 'bg24', label: '精选背景 24', imageUrl: '/images/website-bg/24.webp', thumbnailUrl: '/images/website-bg/thumbs/24.webp' },
  { key: 'bg25', label: '精选背景 25', imageUrl: '/images/website-bg/25.webp', thumbnailUrl: '/images/website-bg/thumbs/25.webp' },
  { key: 'bg26', label: '精选背景 26', imageUrl: '/images/website-bg/26.webp', thumbnailUrl: '/images/website-bg/thumbs/26.webp' },
  { key: 'bg27', label: '精选背景 27', imageUrl: '/images/website-bg/27.webp', thumbnailUrl: '/images/website-bg/thumbs/27.webp' },
  { key: 'bg28', label: '精选背景 28', imageUrl: '/images/website-bg/28.webp', thumbnailUrl: '/images/website-bg/thumbs/28.webp' },
  { key: 'bg29', label: '精选背景 29', imageUrl: '/images/website-bg/29.webp', thumbnailUrl: '/images/website-bg/thumbs/29.webp' },
  { key: 'bg30', label: '精选背景 30', imageUrl: '/images/website-bg/30.webp', thumbnailUrl: '/images/website-bg/thumbs/30.webp' },
  { key: 'bg31', label: '精选背景 31', imageUrl: '/images/website-bg/31.webp', thumbnailUrl: '/images/website-bg/thumbs/31.webp' },
  { key: 'bg32', label: '精选背景 32', imageUrl: '/images/website-bg/32.webp', thumbnailUrl: '/images/website-bg/thumbs/32.webp' },
  { key: 'bg33', label: '精选背景 33', imageUrl: '/images/website-bg/33.webp', thumbnailUrl: '/images/website-bg/thumbs/33.webp' },
  { key: 'bg34', label: '精选背景 34', imageUrl: '/images/website-bg/34.webp', thumbnailUrl: '/images/website-bg/thumbs/34.webp' },
  { key: 'bg35', label: '精选背景 35', imageUrl: '/images/website-bg/35.webp', thumbnailUrl: '/images/website-bg/thumbs/35.webp' },
  { key: 'bg36', label: '精选背景 36', imageUrl: '/images/website-bg/36.webp', thumbnailUrl: '/images/website-bg/thumbs/36.webp' },
  { key: 'bg37', label: '精选背景 37', imageUrl: '/images/website-bg/37.webp', thumbnailUrl: '/images/website-bg/thumbs/37.webp' },
  { key: 'bg38', label: '精选背景 38', imageUrl: '/images/website-bg/38.webp', thumbnailUrl: '/images/website-bg/thumbs/38.webp' },
  { key: 'bg39', label: '精选背景 39', imageUrl: '/images/website-bg/39.webp', thumbnailUrl: '/images/website-bg/thumbs/39.webp' },
  { key: 'bg40', label: '精选背景 40', imageUrl: '/images/website-bg/40.webp', thumbnailUrl: '/images/website-bg/thumbs/40.webp' },
  { key: 'bg41', label: '精选背景 41', imageUrl: '/images/website-bg/41.webp', thumbnailUrl: '/images/website-bg/thumbs/41.webp' },
  { key: 'bg42', label: '精选背景 42', imageUrl: '/images/website-bg/42.webp', thumbnailUrl: '/images/website-bg/thumbs/42.webp' },
  { key: 'bg43', label: '精选背景 43', imageUrl: '/images/website-bg/43.webp', thumbnailUrl: '/images/website-bg/thumbs/43.webp' },
]

export const CRM_ADVANCED_CUSTOM_BACKGROUND_KEY = 'custom'
export const CRM_ADVANCED_OVERLAY_MIN = 30
export const CRM_ADVANCED_OVERLAY_MAX = 70
export const CRM_ADVANCED_DEFAULT_OVERLAY_OPACITY = 50
/** 平台默认展示顺序（amazon, tiktok, walmart, bestbuy, official_website） */
export const CRM_ADVANCED_DEFAULT_PLATFORM_ORDER: CrmOrderMatchPlatform[] = [
  'amazon',
  'tiktok',
  'walmart',
  'bestbuy',
  'official_website',
]
export const CRM_ADVANCED_DEFAULT_ACCENT_COLOR = '#2563eb'
export const CRM_ADVANCED_WHY_COUNT = 4
export const CRM_ADVANCED_FAQ_COUNT = 6
/** 高级版 Header 自定义菜单链接最大条数 */
export const CRM_ADVANCED_MENU_LINK_COUNT = 6

/** 判断是否为外部完整 URL：http(s):// 或 // 开头，或裸域名（如 www.example.com）。 */
export const isCrmAdvancedMenuExternalUrl = (url: string): boolean => {
  const normalized = String(url ?? '').trim()
  if (!normalized) return false
  if (/^(https?:)?\/\//i.test(normalized)) return true
  // 裸域名：至少包含一个点且不以 / ? # 开头（如 www.example.com / example.com/path）
  return /^[a-z0-9-]+(\.[a-z0-9-]+)+([/:?#].*)?$/i.test(normalized)
}

/** 外部链接 href 归一化：裸域名自动补 https://，避免被浏览器当成站内相对路径。 */
export const normalizeCrmAdvancedExternalUrl = (url: string): string => {
  const normalized = String(url ?? '').trim()
  if (/^(https?:)?\/\//i.test(normalized)) return normalized
  if (/^[a-z0-9-]+(\.[a-z0-9-]+)+([/:?#].*)?$/i.test(normalized)) return `https://${normalized}`
  return normalized
}

/** 高级版渐变色主题 */
export interface CrmAdvancedGradientTheme {
  key: string
  /** 中文展示名 */
  label: string
  /** 渐变起始色（较浅的一端） */
  from: string
  /** 渐变结束色（较深的一端） */
  to: string
  /** 重点文字色：取渐变色中较深的一档，用于标题、链接等关键文字 */
  text: string
}

/** 不使用渐变色主题（沿用主体色） */
export const CRM_ADVANCED_NO_GRADIENT_KEY = ''

/** 高级版默认渐变色主题 key（新站点/空配置默认使用蓝橙渐变） */
export const CRM_ADVANCED_DEFAULT_GRADIENT_KEY = 'blue-orange'

/** 高级版预设渐变色主题（共 20 套，含蓝橙渐变） */
export const CRM_ADVANCED_GRADIENT_THEMES: CrmAdvancedGradientTheme[] = [
  {
    key: 'blue-orange',
    label: '晴空海岸 · 蓝橙',
    from: '#2563eb',
    to: '#ea580c',
    text: '#1e3a8a',
  },
  {
    key: 'purple-pink',
    label: '紫粉梦境',
    from: '#7c3aed',
    to: '#db2777',
    text: '#581c87',
  },
  {
    key: 'cyan-blue',
    label: '海洋之心',
    from: '#0891b2',
    to: '#1e40af',
    text: '#0c4a6e',
  },
  {
    key: 'amber-red',
    label: '落日熔金',
    from: '#f59e0b',
    to: '#dc2626',
    text: '#b45309',
  },
  {
    key: 'emerald',
    label: '翡翠流光',
    from: '#10b981',
    to: '#047857',
    text: '#064e3b',
  },
  {
    key: 'indigo-violet',
    label: '星河夜紫',
    from: '#4f46e5',
    to: '#7e22ce',
    text: '#312e81',
  },
  {
    key: 'rose',
    label: '珊瑚绯霞',
    from: '#f43f5e',
    to: '#be185d',
    text: '#881337',
  },
  {
    key: 'teal-green',
    label: '青苔松风',
    from: '#0d9488',
    to: '#14532d',
    text: '#134e4a',
  },
  {
    key: 'sky-navy',
    label: '深海蓝调',
    from: '#0ea5e9',
    to: '#1e3a8a',
    text: '#172554',
  },
  {
    key: 'slate-ink',
    label: '石墨夜幕',
    from: '#475569',
    to: '#1e293b',
    text: '#0f172a',
  },
  // ── 第二批（2026-08-20 新增 10 套）────────────────────────────
  // 彩色鲜艳
  {
    key: 'lime-turquoise',
    label: '柠檬青碧',
    from: '#a3e635',
    to: '#14b8a6',
    text: '#3f6212',
  },
  {
    key: 'orange-magenta',
    label: '橙紫霓虹',
    from: '#fb923c',
    to: '#db2777',
    text: '#9a3412',
  },
  {
    key: 'crimson-gold',
    label: '绯红鎏金',
    from: '#f43f5e',
    to: '#f59e0b',
    text: '#9f1239',
  },
  {
    key: 'violet-azure',
    label: '紫罗兰晴',
    from: '#8b5cf6',
    to: '#0ea5e9',
    text: '#5b21b6',
  },
  // 柔和浅色
  {
    key: 'blush-lilac',
    label: '浅粉丁香',
    from: '#fbcfe8',
    to: '#c4b5fd',
    text: '#9d174d',
  },
  {
    key: 'sky-mint',
    label: '天蓝薄荷',
    from: '#bae6fd',
    to: '#a7f3d0',
    text: '#0c4a6e',
  },
  {
    key: 'peach-cream',
    label: '蜜桃奶油',
    from: '#fed7aa',
    to: '#fbcfe8',
    text: '#9a3412',
  },
  // 自然大地色系
  {
    key: 'olive-forest',
    label: '橄榄森林',
    from: '#65a30d',
    to: '#166534',
    text: '#365314',
  },
  {
    key: 'sand-cocoa',
    label: '沙金可可',
    from: '#d6a354',
    to: '#7c4a1e',
    text: '#713f12',
  },
  {
    key: 'moss-slate',
    label: '苔石灰岩',
    from: '#4d7c0f',
    to: '#475569',
    text: '#365314',
  },
]

export const getCrmAdvancedGradientTheme = (key: string): CrmAdvancedGradientTheme | null =>
  CRM_ADVANCED_GRADIENT_THEMES.find((theme) => theme.key === key) || null

/**
 * 根据站点标识（id/域名/品牌名）确定性挑选一套渐变色主题，保证每个客户的默认渐变各不相同。
 * 空 seed 时回退到平台默认渐变。
 */
export const resolveCrmAdvancedDefaultGradientKey = (seed: string): string => {
  const normalizedSeed = String(seed ?? '').trim()
  if (!normalizedSeed) return CRM_ADVANCED_DEFAULT_GRADIENT_KEY
  let hash = 0
  for (let i = 0; i < normalizedSeed.length; i += 1) {
    hash = (hash * 31 + normalizedSeed.charCodeAt(i)) >>> 0
  }
  return CRM_ADVANCED_GRADIENT_THEMES[hash % CRM_ADVANCED_GRADIENT_THEMES.length].key
}

export interface CrmAdvancedGradientCss {
  /** 按钮/强调元素背景渐变（未选渐变时为与主体色相同的纯色渐变） */
  gradient: string
  /** 重点文字色（未选渐变时回退为主体色） */
  primary: string
  /** 首屏背景柔光渐变（未选渐变时为 transparent） */
  wash: string
}

/** 解析高级版渐变色 CSS 变量；未配置渐变主题时回退到主体色。 */
export const resolveCrmAdvancedGradientCss = (
  settings: Pick<CrmAdvancedSiteSettings, 'themeGradientKey'> | null,
  fallbackPrimary: string,
): CrmAdvancedGradientCss => {
  const theme = settings ? getCrmAdvancedGradientTheme(settings.themeGradientKey) : null
  if (!theme) {
    return {
      gradient: `linear-gradient(135deg, ${fallbackPrimary}, ${fallbackPrimary})`,
      primary: fallbackPrimary,
      // 注意：wash 会被当作 background-image 层使用，transparent 是颜色（非法图片）会让整条声明失效，必须用 none
      wash: 'none',
    }
  }
  return {
    gradient: `linear-gradient(135deg, ${theme.from}, ${theme.to})`,
    primary: theme.text,
    wash: `linear-gradient(135deg, color-mix(in srgb, ${theme.from} 26%, white), color-mix(in srgb, ${theme.to} 34%, white))`,
  }
}

/**
 * 渐变色主题的推荐模块配色（供自定义官网每个模块的背景色/字体色推荐）。
 * 基于 from/to 用 color-mix 与白色/黑色混合派生，未选渐变时回退为主体色派生。
 * 提供三档背景：浅色（soft）/ 次浅（alt）/ 深色（deep），每档带推荐字体色。
 */
export interface CrmAdvancedSectionPalette {
  /** 主题 key（'' = 未选渐变，按主体色派生） */
  key: string
  /** 浅色背景：主题色与白色 92% 混合（极浅，适合大面积白底交替） */
  bgSoft: string
  /** 次浅背景：主题色与白色 78% 混合（明显着色，适合隔行强调） */
  bgAlt: string
  /** 深色背景：主题渐变 or 主题色（适合强对比区块） */
  bgDeep: string
  /** 白色背景上的推荐文字色（深色，可读性好） */
  textOnWhite: string
  /** 浅色/次浅背景上的推荐文字色（深色） */
  textOnSoft: string
  /** 深色背景上的推荐文字色（白色） */
  textOnDeep: string
}

/** 把一个 hex 颜色与目标色按 weight 混合（weight 为目标色占比，0~1）。 */
const mixCrmHexColor = (hex: string, target: string, weight: number): string => {
  const parse = (value: string) => {
    const clean = String(value || '').replace('#', '')
    const full = clean.length === 3 ? clean.split('').map((c) => c + c).join('') : clean
    const num = Number.parseInt(full, 16)
    if (!Number.isFinite(num) || full.length !== 6) return null
    return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 }
  }
  const source = parse(hex)
  const dest = parse(target)
  if (!source || !dest) return hex
  const mix = (a: number, b: number) => Math.round(a * (1 - weight) + b * weight)
  const r = mix(source.r, dest.r)
  const g = mix(source.g, dest.g)
  const b = mix(source.b, dest.b)
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`
}

/** 根据渐变主题（或主体色）派生一档推荐模块配色。 */
export const getCrmAdvancedSectionPalette = (
  gradientKey: string,
  fallbackPrimary = CRM_ADVANCED_DEFAULT_ACCENT_COLOR,
): CrmAdvancedSectionPalette => {
  const theme = gradientKey ? getCrmAdvancedGradientTheme(gradientKey) : null
  const primary = theme ? theme.from : fallbackPrimary
  const deep = theme ? theme.to : fallbackPrimary
  const textBase = theme ? theme.text : fallbackPrimary

  return {
    key: theme?.key || '',
    bgSoft: mixCrmHexColor(primary, '#ffffff', 0.92),
    bgAlt: mixCrmHexColor(primary, '#ffffff', 0.78),
    bgDeep: deep,
    textOnWhite: textBase,
    textOnSoft: textBase,
    textOnDeep: '#ffffff',
  }
}
/** 首页首屏（Section 1）主标题 / 副标题默认文案 */
export const CRM_ADVANCED_HERO_TITLE_DEFAULT =
  'Our customers are our most valued asset.'
export const CRM_ADVANCED_HERO_SUBTITLE_DEFAULT = 'Your trust matters to us.'
/** 首页/表单页首屏文字上下间距范围（px） */
export const CRM_ADVANCED_HERO_TEXT_GAP_MIN = 8
export const CRM_ADVANCED_HERO_TEXT_GAP_MAX = 48
export const CRM_ADVANCED_HERO_TEXT_GAP_DEFAULT = 16
/** 首页/表单页首屏模块上下内边距范围（px） */
export const CRM_ADVANCED_HERO_PADDING_MIN = 16
export const CRM_ADVANCED_HERO_PADDING_MAX = 160
export const CRM_ADVANCED_HERO_PADDING_DEFAULT = 72
/** 首页/表单页首屏主标题字号范围（px） */
export const CRM_ADVANCED_HERO_TITLE_SIZE_MIN = 24
export const CRM_ADVANCED_HERO_TITLE_SIZE_MAX = 96
export const CRM_ADVANCED_HERO_TITLE_SIZE_DEFAULT = 52
/** FAQ 答案中会自动替换为该官网客服邮箱的占位符 */
export const CRM_ADVANCED_FAQ_EMAIL_TOKEN = '{email}'
export const CRM_ADVANCED_CUSTOM_BG_MAX_BYTES = 10 * 1024 * 1024
export const CRM_ADVANCED_CUSTOM_BG_MAX_LABEL = '10MB'
export const CRM_ADVANCED_CUSTOM_BG_TYPES = ['image/jpeg', 'image/png', 'image/webp'] as const

export const crmAdvancedIconKeys: CrmAdvancedIconKey[] = [
  'clock',
  'shield',
  'truck',
  'headset',
  'lock',
  'check',
  'star',
  'mail',
  'box',
  'leaf',
  'users',
  'heart',
]

export const isCrmAdvancedIconKey = (value: unknown): value is CrmAdvancedIconKey =>
  crmAdvancedIconKeys.includes(value as CrmAdvancedIconKey)

const OVERLAY_MODES: CrmAdvancedOverlayMode[] = ['none', 'black', 'white']

/** 客服页面流程类型（用于定制表单、权益与 FAQ 内容）。 */
export type { CrmAdvancedFlowType } from '@/types/crm'

const cloneGenericWhyItems = (): CrmAdvancedWhyItem[] => [
  {
    icon: 'clock',
    title: '24-Hour Response',
    subtitle: 'We reply to every message within 24 hours on business days.',
  },
  {
    icon: 'shield',
    title: 'Secure & Encrypted',
    subtitle: 'Your order details are encrypted and only used to verify your purchase.',
  },
  {
    icon: 'truck',
    title: 'Free Shipping',
    subtitle: 'Your selected benefit ships free to the address you provide.',
  },
  {
    icon: 'headset',
    title: 'Dedicated Support',
    subtitle: 'Our team follows up on every request until it is fully resolved.',
  },
]

const cloneGenericFaqItems = (): CrmAdvancedFaqItem[] => [
  {
    question: 'How do I contact you?',
    answer: `You can reach us any time at ${CRM_ADVANCED_FAQ_EMAIL_TOKEN}. Our team reads every message and replies as soon as possible.`,
  },
  {
    question: 'How soon will I get a reply?',
    answer:
      'We reply within 24 hours on business days and keep following up on complex issues until they are resolved.',
  },
  {
    question: 'Is my order information secure?',
    answer:
      'Yes. Your information is encrypted and only used to verify your purchase — never for anything else.',
  },
  {
    question: 'What happens after I submit?',
    answer:
      'We verify your order, then guide you to choose your benefit and confirm your shipping address.',
  },
  {
    question: 'How is my benefit shipped?',
    answer:
      "After your address is confirmed, it ships free and we'll notify you once it is on the way.",
  },
  {
    question: 'What if I forgot my order ID?',
    answer:
      "You can find it in your order history on the store platform. If you still need help, email us and we'll assist you.",
  },
]

/** Warranty 专属权益（Section 2） */
const createWarrantyWhyItems = (): CrmAdvancedWhyItem[] => [
  {
    icon: 'shield',
    title: '3-Year Warranty',
    subtitle: 'Your product is covered by a full 3-year warranty from the date of purchase.',
  },
  {
    icon: 'headset',
    title: 'Lifetime Free Consultation',
    subtitle: 'Talk to our product experts for free, any time you need advice.',
  },
  {
    icon: 'clock',
    title: 'Fast Response Channel',
    subtitle: 'A dedicated fast-response channel answers your warranty questions quickly.',
  },
  {
    icon: 'truck',
    title: 'Free Replacement Shipping',
    subtitle: 'Eligible warranty benefits ship to you with no shipping charges.',
  },
]

/** Registry 专属权益（Section 2） */
const createRegistryWhyItems = (): CrmAdvancedWhyItem[] => [
  {
    icon: 'check',
    title: 'Free Registry Sample',
    subtitle: "Get a free sample from your product's registry benefit list.",
  },
  {
    icon: 'headset',
    title: 'Lifetime Free Consultation',
    subtitle: 'Talk to our product experts for free, any time you need advice.',
  },
  {
    icon: 'clock',
    title: 'Fast Response Channel',
    subtitle: 'A dedicated fast-response channel answers your registry questions quickly.',
  },
  {
    icon: 'box',
    title: 'Product Tips & Updates',
    subtitle: 'Receive care tips and updates to get the most from your registered product.',
  },
]

/** OMB 专属权益（Section 2） */
const createOmbWhyItems = (): CrmAdvancedWhyItem[] => [
  {
    icon: 'box',
    title: 'One More Bottle',
    subtitle: 'Claim one extra bottle of your product at no extra cost.',
  },
  {
    icon: 'headset',
    title: 'Lifetime Free Consultation',
    subtitle: 'Talk to our product experts for free, any time you need advice.',
  },
  {
    icon: 'clock',
    title: 'Fast Response Channel',
    subtitle: 'A dedicated fast-response channel answers your OMB questions quickly.',
  },
  {
    icon: 'truck',
    title: 'Free Shipping',
    subtitle: 'Your One More Bottle ships free to the address you provide.',
  },
]

/** Warranty 专属 FAQ */
const createWarrantyFaqItems = (): CrmAdvancedFaqItem[] => [
  {
    question: 'How long does my warranty last?',
    answer:
      'Your product is covered for 3 years from the date of purchase. You can start a claim at any time within that period.',
  },
  {
    question: 'Does the warranty cost anything?',
    answer:
      'No — warranty activation is completely free. There are no shipping charges, no hidden fees, and no credit card required.',
  },
  {
    question: 'What does the warranty include?',
    answer:
      'Your warranty includes a fast-response support channel, lifetime free consultation, and free shipping for eligible replacement benefits.',
  },
  {
    question: 'How do I contact you?',
    answer: `You can reach us any time at ${CRM_ADVANCED_FAQ_EMAIL_TOKEN}. Our team reads every message and replies as soon as possible.`,
  },
  {
    question: 'Is my order information secure?',
    answer:
      'Yes. Your information is encrypted and only used to verify your purchase — never for anything else.',
  },
  {
    question: 'What if I forgot my order ID?',
    answer:
      "You can find it in your order history on the store platform. If you still need help, email us and we'll assist you.",
  },
]

/** Registry 专属 FAQ */
const createRegistryFaqItems = (): CrmAdvancedFaqItem[] => [
  {
    question: 'What do I get for registering?',
    answer:
      'After registering, you can choose a free sample from the registry benefit list and enjoy lifetime free consultation.',
  },
  {
    question: 'Does registration cost anything?',
    answer:
      'No — registration is completely free. There are no shipping charges, no hidden fees, and no credit card required.',
  },
  {
    question: 'What happens after I register?',
    answer:
      'We verify your order, then let you choose your free sample and confirm your shipping address.',
  },
  {
    question: 'How do I contact you?',
    answer: `You can reach us any time at ${CRM_ADVANCED_FAQ_EMAIL_TOKEN}. Our team reads every message and replies as soon as possible.`,
  },
  {
    question: 'Is my order information secure?',
    answer:
      'Yes. Your information is encrypted and only used to verify your purchase — never for anything else.',
  },
  {
    question: 'What if I forgot my order ID?',
    answer:
      "You can find it in your order history on the store platform. If you still need help, email us and we'll assist you.",
  },
]

/** OMB 专属 FAQ */
const createOmbFaqItems = (): CrmAdvancedFaqItem[] => [
  {
    question: 'What do I get with my OMB claim?',
    answer:
      'You can claim one extra bottle of your product, free of shipping charges and hidden fees.',
  },
  {
    question: 'Does the OMB claim cost anything?',
    answer:
      'No — the claim is completely free. There are no shipping charges, no hidden fees, and no credit card required.',
  },
  {
    question: 'What happens after I submit my claim?',
    answer:
      'We verify your order, then let you choose your One More Bottle and confirm your shipping address.',
  },
  {
    question: 'How do I contact you?',
    answer: `You can reach us any time at ${CRM_ADVANCED_FAQ_EMAIL_TOKEN}. Our team reads every message and replies as soon as possible.`,
  },
  {
    question: 'Is my order information secure?',
    answer:
      'Yes. Your information is encrypted and only used to verify your purchase — never for anything else.',
  },
  {
    question: 'What if I forgot my order ID?',
    answer:
      "You can find it in your order history on the store platform. If you still need help, email us and we'll assist you.",
  },
]

/** 各流程 Section 2 标题 */
export const createDefaultCrmAdvancedWhyTitle = (flowType: CrmServicePageType): string => {
  switch (flowType) {
    case 'warranty':
      return 'What Will You Get After Activating The Warranty?'
    case 'registry':
      return 'What Will You Get After Registering The Order?'
    case 'omb':
      return 'What Will You Get After Starting Your OMB Claim?'
    default:
      return 'Why Choose Us?'
  }
}

export const createDefaultCrmAdvancedWhyItems = (
  flowType: CrmServicePageType,
): CrmAdvancedWhyItem[] => {
  switch (flowType) {
    case 'warranty':
      return createWarrantyWhyItems()
    case 'registry':
      return createRegistryWhyItems()
    case 'omb':
      return createOmbWhyItems()
    default:
      return cloneGenericWhyItems()
  }
}

export const createDefaultCrmAdvancedFaqItems = (
  flowType: CrmServicePageType,
): CrmAdvancedFaqItem[] => {
  switch (flowType) {
    case 'warranty':
      return createWarrantyFaqItems()
    case 'registry':
      return createRegistryFaqItems()
    case 'omb':
      return createOmbFaqItems()
    default:
      return cloneGenericFaqItems()
  }
}

export const crmAdvancedFlowTypes: CrmAdvancedFlowType[] = ['warranty', 'registry', 'omb']

/**
 * 客户公开页面当前使用的流程文案。新建配置与旧站点升级均以此为默认值，
 * 让后台所见、所改内容和线上实际渲染内容保持一致。
 */
export const createDefaultCrmAdvancedFlowContent = (
  flowType: CrmAdvancedFlowType,
): CrmAdvancedFlowContent => {
  const shared = {
    activationEyebrow: '',
    congratsEyebrow: 'Congratulations',
    congratsBannerTitle: 'Congratulations!',
    experienceEyebrow: 'Step 1 of 3',
    shareEyebrow: 'Step 2 of 3',
    addressEyebrow: 'Final Steps',
    reviewProgressLabels: ['Review', 'Share', 'Address'] as [string, string, string],
    platformContextPrefix: 'The current platform is',
    faqTitle: 'Frequently Asked Questions',
  }

  if (flowType === 'warranty') {
    return {
      ...shared,
      navigationLabel: 'Warranty',
      activationTitle: 'Activate Your Warranty',
      activationDescription: 'Activate your warranty and enjoy more benefits.',
      startButton: 'Activate Warranty',
      processName: 'warranty activation',
      congratsStepTitle: 'Your Warranty Has Been Activated',
      congratsStepDescription:
        'Congratulations! You can now additionally apply for one Extra Accessory — no shipping fee and no extra cost.',
      congratsBannerDescription:
        'You can now additionally apply for one Extra Accessory — no shipping fee and no extra cost.',
      experienceTitle: 'Tell Us About Your Warranty Product',
      experienceDescription:
        'Confirm the product covered by this warranty, then share an honest rating and comment.',
      shareTitle: 'Share Your Warranty Product Experience',
      shareDescription: 'Use the comment you already wrote and complete the review step when required.',
      addressTitle: 'Confirm Your Extra Accessories Shipping Address',
      addressDescription:
        'Review your warranty product and selected extra accessories, then tell us where they should be sent.',
      reviewContinuation: 'warranty activation',
      selectedItemLabel: 'Selected extra accessory',
      shippingLead: 'We will ship your selected extra accessories to:',
      finalSubmitLabel: 'Submit Warranty',
      completionMessage:
        'You have completed your warranty activation. We will confirm your Extra Accessory and ship it to you as soon as possible.',
      whyTitle: createDefaultCrmAdvancedWhyTitle(flowType),
      whyItems: createDefaultCrmAdvancedWhyItems(flowType),
      faqItems: createDefaultCrmAdvancedFaqItems(flowType),
    }
  }

  if (flowType === 'omb') {
    return {
      ...shared,
      navigationLabel: 'OMB',
      activationTitle: 'Register Your Order and Claim One More Bottle',
      activationDescription:
        'Enter your purchase details to start the One More Bottle claim for your eligible product.',
      startButton: 'Start OMB Claim',
      processName: 'One More Bottle claim',
      congratsStepTitle: 'Your One More Bottle Claim Has Been Started',
      congratsStepDescription:
        'Congratulations! You can now additionally apply for one One More Bottle — no shipping fee and no extra cost.',
      congratsBannerDescription:
        'You can now additionally apply for one One More Bottle — no shipping fee and no extra cost.',
      experienceTitle: 'Tell Us About Your OMB Product',
      experienceDescription:
        'Confirm the product connected to this One More Bottle claim, then share an honest rating and comment.',
      shareTitle: 'Share Your Product Experience',
      shareDescription: 'Use the comment you already wrote and complete the review step when required.',
      addressTitle: 'Confirm Your One More Bottle Shipping Address',
      addressDescription:
        'Review your purchased product and selected One More Bottle item, then tell us where it should be sent.',
      reviewContinuation: 'One More Bottle claim',
      selectedItemLabel: 'Selected One More Bottle item',
      shippingLead: 'We will ship your selected One More Bottle item to:',
      finalSubmitLabel: 'Submit OMB Claim',
      completionMessage:
        'You have completed your One More Bottle claim. We will confirm your OMB claim and ship it to you as soon as possible.',
      whyTitle: createDefaultCrmAdvancedWhyTitle(flowType),
      whyItems: createDefaultCrmAdvancedWhyItems(flowType),
      faqItems: createDefaultCrmAdvancedFaqItems(flowType),
    }
  }

  return {
    ...shared,
    navigationLabel: 'Registry',
    activationTitle: 'Register Your Product',
    activationDescription:
      'Enter your purchase details to register your product and continue to the available registry benefits.',
    startButton: 'Register Product',
    processName: 'product registry',
    congratsStepTitle: 'Your Product Has Been Registered',
    congratsStepDescription:
      'Congratulations! You can now additionally apply for one Extra Accessory — no shipping fee and no extra cost.',
    congratsBannerDescription:
      'You can now additionally apply for one Extra Accessory — no shipping fee and no extra cost.',
    experienceTitle: 'Tell Us About Your Registered Product',
    experienceDescription:
      'Confirm the product you are registering, then share an honest rating and comment.',
    shareTitle: 'Share Your Registered Product Experience',
    shareDescription: 'Use the comment you already wrote and complete the review step when required.',
    addressTitle: 'Confirm Your Registry Sample Shipping Address',
    addressDescription:
      'Review your registered product and selected sample, then tell us where the registry sample should be sent.',
    reviewContinuation: 'product registry',
    selectedItemLabel: 'Selected registry sample',
    shippingLead: 'We will ship your selected registry sample to:',
    finalSubmitLabel: 'Submit Registry',
    completionMessage:
      'You have completed your product registration. We will confirm your Extra Accessory and ship it to you as soon as possible.',
    whyTitle: createDefaultCrmAdvancedWhyTitle(flowType),
    whyItems: createDefaultCrmAdvancedWhyItems(flowType),
    faqItems: createDefaultCrmAdvancedFaqItems(flowType),
  }
}

export const createDefaultCrmAdvancedFlowContents = (): Record<
  CrmAdvancedFlowType,
  CrmAdvancedFlowContent
> => ({
  warranty: createDefaultCrmAdvancedFlowContent('warranty'),
  registry: createDefaultCrmAdvancedFlowContent('registry'),
  omb: createDefaultCrmAdvancedFlowContent('omb'),
})

/** 判断权益/FAQ 是否仍为旧版通用默认内容（用于渲染时按流程替换为专属内容） */
const isSameItems = <T extends { icon?: string; question?: string }>(
  left: T[],
  right: T[],
): boolean =>
  left.length === right.length &&
  left.every((item, index) => {
    const other = right[index]
    return Boolean(other) && JSON.stringify(item) === JSON.stringify(other)
  })

/**
 * 渲染时的流程化展示内容：当站点存储的权益/FAQ 仍是旧版通用默认（或为空）时，
 * 按 Warranty/Registry/OMB 替换为专属内容；站点已自定义的内容保持不变。
 */
export const resolveCrmAdvancedDisplaySettings = (
  settings: CrmAdvancedSiteSettings,
  flowType: CrmServicePageType,
): CrmAdvancedSiteSettings => {
  if (flowType === 'homepage' || flowType === 'no_order_needed') return settings
  const configuredFlowContent = settings.flowContents?.[flowType]
  if (configuredFlowContent) {
    return {
      ...settings,
      whyTitle: configuredFlowContent.whyTitle,
      whyItems: configuredFlowContent.whyItems,
      faqTitle: configuredFlowContent.faqTitle,
      faqItems: configuredFlowContent.faqItems,
    }
  }
  const usesLegacyWhy =
    !settings.whyItems.length || isSameItems(settings.whyItems, cloneGenericWhyItems())
  const usesLegacyFaq =
    !settings.faqItems.length || isSameItems(settings.faqItems, cloneGenericFaqItems())
  if (!usesLegacyWhy && !usesLegacyFaq) return settings
  return {
    ...settings,
    whyTitle: usesLegacyWhy ? createDefaultCrmAdvancedWhyTitle(flowType) : settings.whyTitle,
    whyItems: usesLegacyWhy ? createDefaultCrmAdvancedWhyItems(flowType) : settings.whyItems,
    faqItems: usesLegacyFaq ? createDefaultCrmAdvancedFaqItems(flowType) : settings.faqItems,
  }
}

export const resolveCrmAdvancedFlowContent = (
  settings: CrmAdvancedSiteSettings,
  flowType: CrmAdvancedFlowType,
): CrmAdvancedFlowContent =>
  settings.flowContents?.[flowType] || createDefaultCrmAdvancedFlowContent(flowType)

export const createDefaultCrmAdvancedSettings = (
  flowType: CrmServicePageType = 'homepage',
  seed = '',
): CrmAdvancedSiteSettings => ({
  version: 1,
  backgroundKey: '',
  customBackgroundUrl: '',
  overlayMode: 'none',
  overlayOpacity: CRM_ADVANCED_DEFAULT_OVERLAY_OPACITY,
  accentColor: CRM_ADVANCED_DEFAULT_ACCENT_COLOR,
  themeGradientKey: resolveCrmAdvancedDefaultGradientKey(seed),
  inheritCustomGradient: true,
  heroBackgroundImage: false,
  menuTitle: '',
  menuTitleUrl: '',
  menuLinks: [],
  platformOrder: [...CRM_ADVANCED_DEFAULT_PLATFORM_ORDER],
  heroTitle: CRM_ADVANCED_HERO_TITLE_DEFAULT,
  heroSubtitle: CRM_ADVANCED_HERO_SUBTITLE_DEFAULT,
  homeHeroTextGap: CRM_ADVANCED_HERO_TEXT_GAP_DEFAULT,
  homeHeroTopPadding: CRM_ADVANCED_HERO_PADDING_DEFAULT,
  homeHeroBottomPadding: CRM_ADVANCED_HERO_PADDING_DEFAULT,
  homeHeroTitleSize: CRM_ADVANCED_HERO_TITLE_SIZE_DEFAULT,
  formHeroTextGap: CRM_ADVANCED_HERO_TEXT_GAP_DEFAULT,
  formHeroTopPadding: CRM_ADVANCED_HERO_PADDING_DEFAULT,
  formHeroBottomPadding: CRM_ADVANCED_HERO_PADDING_DEFAULT,
  formHeroTitleSize: CRM_ADVANCED_HERO_TITLE_SIZE_DEFAULT,
  whyTitle: createDefaultCrmAdvancedWhyTitle(flowType),
  whyItems: createDefaultCrmAdvancedWhyItems(flowType),
  faqTitle: 'Frequently Asked Questions',
  faqItems: createDefaultCrmAdvancedFaqItems(flowType),
  flowContents: createDefaultCrmAdvancedFlowContents(),
  sharePage: normalizeCrmSharePageSettings(null),
})

const cleanText = (value: unknown, limit = 500): string =>
  String(value ?? '').trim().slice(0, limit)

const normalizeWhyItems = (value: unknown, flowType: CrmServicePageType): CrmAdvancedWhyItem[] => {
  const defaults = createDefaultCrmAdvancedWhyItems(flowType)
  if (!Array.isArray(value) || !value.length) return defaults

  const normalized = value
    .slice(0, CRM_ADVANCED_WHY_COUNT)
    .map((item, index) => {
      const fallback = defaults[index] || defaults[0]
      const raw = item && typeof item === 'object' ? (item as Record<string, unknown>) : {}
      return {
        icon: isCrmAdvancedIconKey(raw.icon) ? raw.icon : fallback.icon,
        title: cleanText(raw.title, 80) || fallback.title,
        subtitle: cleanText(raw.subtitle, 200) || fallback.subtitle,
      }
    })

  while (normalized.length < CRM_ADVANCED_WHY_COUNT) {
    normalized.push(defaults[normalized.length] || defaults[0])
  }
  return normalized
}

const normalizeFaqItems = (value: unknown, flowType: CrmServicePageType): CrmAdvancedFaqItem[] => {
  const defaults = createDefaultCrmAdvancedFaqItems(flowType)
  if (!Array.isArray(value) || !value.length) return defaults

  const normalized = value
    .slice(0, CRM_ADVANCED_FAQ_COUNT)
    .map((item, index) => {
      const fallback = defaults[index] || defaults[0]
      const raw = item && typeof item === 'object' ? (item as Record<string, unknown>) : {}
      return {
        question: cleanText(raw.question, 160) || fallback.question,
        answer: cleanText(raw.answer, 1000) || fallback.answer,
      }
    })

  while (normalized.length < CRM_ADVANCED_FAQ_COUNT) {
    normalized.push(defaults[normalized.length] || defaults[0])
  }
  return normalized
}

const normalizeReviewProgressLabels = (
  value: unknown,
  fallback: [string, string, string],
): [string, string, string] => {
  const raw = Array.isArray(value) ? value : []
  return [0, 1, 2].map(
    (index) => cleanText(raw[index], 40) || fallback[index],
  ) as [string, string, string]
}

type LegacyFlowSectionFallback = Pick<
  CrmAdvancedFlowContent,
  'whyTitle' | 'whyItems' | 'faqTitle' | 'faqItems'
> & {
  whyTitleCustomized: boolean
  whyItemsCustomized: boolean
  faqTitleCustomized: boolean
  faqItemsCustomized: boolean
}

const createLegacyFlowContentFallback = (
  flowType: CrmAdvancedFlowType,
  legacy: LegacyFlowSectionFallback,
): CrmAdvancedFlowContent => {
  const defaults = createDefaultCrmAdvancedFlowContent(flowType)
  return {
    ...defaults,
    whyTitle: legacy.whyTitleCustomized ? legacy.whyTitle : defaults.whyTitle,
    whyItems: legacy.whyItemsCustomized ? legacy.whyItems : defaults.whyItems,
    faqTitle: legacy.faqTitleCustomized ? legacy.faqTitle : defaults.faqTitle,
    faqItems: legacy.faqItemsCustomized ? legacy.faqItems : defaults.faqItems,
  }
}

const normalizeCrmAdvancedFlowContent = (
  value: unknown,
  flowType: CrmAdvancedFlowType,
  legacy: LegacyFlowSectionFallback,
): CrmAdvancedFlowContent => {
  const fallback = createLegacyFlowContentFallback(flowType, legacy)
  const raw = value && typeof value === 'object' ? (value as Record<string, unknown>) : {}
  return {
    navigationLabel: cleanText(raw.navigationLabel, 60) || fallback.navigationLabel,
    activationEyebrow: cleanText(raw.activationEyebrow, 80) || fallback.activationEyebrow,
    activationTitle: cleanText(raw.activationTitle, 160) || fallback.activationTitle,
    activationDescription:
      cleanText(raw.activationDescription, 400) || fallback.activationDescription,
    startButton: cleanText(raw.startButton, 80) || fallback.startButton,
    processName: cleanText(raw.processName, 120) || fallback.processName,
    congratsEyebrow: cleanText(raw.congratsEyebrow, 80) || fallback.congratsEyebrow,
    congratsStepTitle: cleanText(raw.congratsStepTitle, 160) || fallback.congratsStepTitle,
    congratsStepDescription:
      cleanText(raw.congratsStepDescription, 400) || fallback.congratsStepDescription,
    congratsBannerTitle:
      cleanText(raw.congratsBannerTitle, 160) || fallback.congratsBannerTitle,
    congratsBannerDescription:
      cleanText(raw.congratsBannerDescription, 400) || fallback.congratsBannerDescription,
    experienceEyebrow: cleanText(raw.experienceEyebrow, 80) || fallback.experienceEyebrow,
    experienceTitle: cleanText(raw.experienceTitle, 160) || fallback.experienceTitle,
    experienceDescription:
      cleanText(raw.experienceDescription, 400) || fallback.experienceDescription,
    shareEyebrow: cleanText(raw.shareEyebrow, 80) || fallback.shareEyebrow,
    shareTitle: cleanText(raw.shareTitle, 160) || fallback.shareTitle,
    shareDescription: cleanText(raw.shareDescription, 400) || fallback.shareDescription,
    platformContextPrefix:
      cleanText(raw.platformContextPrefix, 120) || fallback.platformContextPrefix,
    addressEyebrow: cleanText(raw.addressEyebrow, 80) || fallback.addressEyebrow,
    addressTitle: cleanText(raw.addressTitle, 160) || fallback.addressTitle,
    addressDescription:
      cleanText(raw.addressDescription, 400) || fallback.addressDescription,
    reviewProgressLabels: normalizeReviewProgressLabels(
      raw.reviewProgressLabels,
      fallback.reviewProgressLabels,
    ),
    reviewContinuation: cleanText(raw.reviewContinuation, 120) || fallback.reviewContinuation,
    selectedItemLabel: cleanText(raw.selectedItemLabel, 120) || fallback.selectedItemLabel,
    shippingLead: cleanText(raw.shippingLead, 240) || fallback.shippingLead,
    finalSubmitLabel: cleanText(raw.finalSubmitLabel, 80) || fallback.finalSubmitLabel,
    completionMessage: cleanText(raw.completionMessage, 400) || fallback.completionMessage,
    whyTitle: cleanText(raw.whyTitle, 120) || fallback.whyTitle,
    whyItems:
      Array.isArray(raw.whyItems) && raw.whyItems.length
        ? normalizeWhyItems(raw.whyItems, flowType)
        : fallback.whyItems,
    faqTitle: cleanText(raw.faqTitle, 120) || fallback.faqTitle,
    faqItems:
      Array.isArray(raw.faqItems) && raw.faqItems.length
        ? normalizeFaqItems(raw.faqItems, flowType)
        : fallback.faqItems,
  }
}

const normalizeCrmAdvancedFlowContents = (
  value: unknown,
  legacy: LegacyFlowSectionFallback,
): Record<CrmAdvancedFlowType, CrmAdvancedFlowContent> => {
  const raw = value && typeof value === 'object' ? (value as Record<string, unknown>) : {}
  return {
    warranty: normalizeCrmAdvancedFlowContent(raw.warranty, 'warranty', legacy),
    registry: normalizeCrmAdvancedFlowContent(raw.registry, 'registry', legacy),
    omb: normalizeCrmAdvancedFlowContent(raw.omb, 'omb', legacy),
  }
}

const normalizeHexColor = (value: unknown): string => {
  const raw = String(value ?? '').trim()
  return /^#[0-9a-fA-F]{6}$/.test(raw) ? raw.toLowerCase() : ''
}

const normalizeOverlayOpacity = (value: unknown): number => {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return CRM_ADVANCED_DEFAULT_OVERLAY_OPACITY
  return Math.min(CRM_ADVANCED_OVERLAY_MAX, Math.max(CRM_ADVANCED_OVERLAY_MIN, Math.round(numeric)))
}

const normalizeHeroTextGap = (value: unknown): number => {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return CRM_ADVANCED_HERO_TEXT_GAP_DEFAULT
  return Math.min(
    CRM_ADVANCED_HERO_TEXT_GAP_MAX,
    Math.max(CRM_ADVANCED_HERO_TEXT_GAP_MIN, Math.round(numeric)),
  )
}

const normalizeHeroPadding = (value: unknown): number => {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return CRM_ADVANCED_HERO_PADDING_DEFAULT
  return Math.min(
    CRM_ADVANCED_HERO_PADDING_MAX,
    Math.max(CRM_ADVANCED_HERO_PADDING_MIN, Math.round(numeric)),
  )
}

const normalizeHeroTitleSize = (value: unknown): number => {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return CRM_ADVANCED_HERO_TITLE_SIZE_DEFAULT
  return Math.min(
    CRM_ADVANCED_HERO_TITLE_SIZE_MAX,
    Math.max(CRM_ADVANCED_HERO_TITLE_SIZE_MIN, Math.round(numeric)),
  )
}

const normalizeBackgroundKey = (value: unknown): string => {
  const raw = String(value ?? '').trim()
  if (raw === CRM_ADVANCED_CUSTOM_BACKGROUND_KEY) return raw
  return CRM_ADVANCED_BACKGROUND_SLOTS.some((slot) => slot.key === raw) ? raw : ''
}

const normalizeCustomBackgroundUrl = (value: unknown): string => {
  const raw = String(value ?? '').trim()
  return /^https:\/\/[^\s]+$/.test(raw) ? raw.slice(0, 2048) : ''
}

/** 平台排序归一化：只保留合法平台、去重，缺失的平台按默认顺序补齐。 */
const normalizePlatformOrder = (value: unknown): CrmOrderMatchPlatform[] => {
  const defaults = CRM_ADVANCED_DEFAULT_PLATFORM_ORDER
  if (!Array.isArray(value) || !value.length) return [...defaults]

  const normalized: CrmOrderMatchPlatform[] = []
  for (const item of value) {
    const key = String(item ?? '').trim() as CrmOrderMatchPlatform
    if (defaults.includes(key) && !normalized.includes(key)) {
      normalized.push(key)
    }
  }
  for (const key of defaults) {
    if (!normalized.includes(key)) normalized.push(key)
  }
  return normalized
}

const normalizeMenuTitle = (value: unknown): string => cleanText(value, 60)

/** 菜单链接归一化：只保留 label 与 url 均非空的条目，最多 6 条。 */
const normalizeMenuLinks = (value: unknown): CrmAdvancedMenuLink[] => {
  if (!Array.isArray(value)) return []
  const links: CrmAdvancedMenuLink[] = []
  for (const item of value) {
    if (links.length >= CRM_ADVANCED_MENU_LINK_COUNT) break
    const raw = item && typeof item === 'object' ? (item as Record<string, unknown>) : {}
    const label = cleanText(raw.label, 40)
    const url = cleanText(raw.url, 500)
    if (!label || !url) continue
    links.push({ label, url, newWindow: raw.newWindow === true })
  }
  return links
}

/** 严格校验 + 回填默认值的归一化；空/非法输入返回完整默认配置。
 * flowType 用于决定权益/FAQ 的默认内容（warranty/registry/omb 各自专属）；
 * seed 为站点标识，用于未配置渐变时按站点挑选不同的默认渐变色。 */
export const normalizeCrmAdvancedSettings = (
  value: unknown,
  flowType: CrmServicePageType = 'homepage',
  seed = '',
): CrmAdvancedSiteSettings => {
  const defaults = createDefaultCrmAdvancedSettings(flowType, seed)
  if (!value || typeof value !== 'object') return defaults

  const raw = value as Record<string, unknown>
  const overlayMode = OVERLAY_MODES.includes(raw.overlayMode as CrmAdvancedOverlayMode)
    ? (raw.overlayMode as CrmAdvancedOverlayMode)
    : 'none'
  const accentColor = normalizeHexColor(raw.accentColor) || CRM_ADVANCED_DEFAULT_ACCENT_COLOR
  const themeGradientKey = getCrmAdvancedGradientTheme(String(raw.themeGradientKey ?? '').trim())
    ? String(raw.themeGradientKey).trim()
    : resolveCrmAdvancedDefaultGradientKey(seed)
  const storedWhyTitle = cleanText(raw.whyTitle, 120)
  const storedFaqTitle = cleanText(raw.faqTitle, 120)
  const hasStoredWhyItems = Array.isArray(raw.whyItems) && raw.whyItems.length > 0
  const hasStoredFaqItems = Array.isArray(raw.faqItems) && raw.faqItems.length > 0
  const legacySectionContent: LegacyFlowSectionFallback = {
    whyTitle: storedWhyTitle || createDefaultCrmAdvancedWhyTitle(flowType),
    whyItems: normalizeWhyItems(raw.whyItems, flowType),
    faqTitle: storedFaqTitle || defaults.faqTitle,
    faqItems: normalizeFaqItems(raw.faqItems, flowType),
    whyTitleCustomized:
      Boolean(storedWhyTitle) && storedWhyTitle !== createDefaultCrmAdvancedWhyTitle('homepage'),
    whyItemsCustomized:
      hasStoredWhyItems &&
      !isSameItems(normalizeWhyItems(raw.whyItems, 'homepage'), cloneGenericWhyItems()),
    faqTitleCustomized:
      Boolean(storedFaqTitle) && storedFaqTitle !== 'Frequently Asked Questions',
    faqItemsCustomized:
      hasStoredFaqItems &&
      !isSameItems(normalizeFaqItems(raw.faqItems, 'homepage'), cloneGenericFaqItems()),
  }
  return {
    version: 1,
    backgroundKey: normalizeBackgroundKey(raw.backgroundKey),
    customBackgroundUrl: normalizeCustomBackgroundUrl(raw.customBackgroundUrl),
    overlayMode,
    overlayOpacity: normalizeOverlayOpacity(raw.overlayOpacity),
    accentColor,
    themeGradientKey,
    inheritCustomGradient: raw.inheritCustomGradient !== false,
    heroBackgroundImage: raw.heroBackgroundImage === true,
    menuTitle: normalizeMenuTitle(raw.menuTitle),
    menuTitleUrl: cleanText(raw.menuTitleUrl, 500),
    menuLinks: normalizeMenuLinks(raw.menuLinks),
    platformOrder: normalizePlatformOrder(raw.platformOrder),
    heroTitle: cleanText(raw.heroTitle, 160) || CRM_ADVANCED_HERO_TITLE_DEFAULT,
    heroSubtitle: cleanText(raw.heroSubtitle, 200) || CRM_ADVANCED_HERO_SUBTITLE_DEFAULT,
    // 兼容旧的共享字段（此前首页/表单页共用一套）作为首页回退
    homeHeroTextGap: normalizeHeroTextGap(raw.homeHeroTextGap ?? raw.heroTextGap),
    homeHeroTopPadding: normalizeHeroPadding(raw.homeHeroTopPadding ?? raw.heroTopPadding),
    homeHeroBottomPadding: normalizeHeroPadding(raw.homeHeroBottomPadding ?? raw.heroBottomPadding),
    homeHeroTitleSize: normalizeHeroTitleSize(raw.homeHeroTitleSize ?? raw.heroTitleSize),
    formHeroTextGap: normalizeHeroTextGap(raw.formHeroTextGap),
    formHeroTopPadding: normalizeHeroPadding(raw.formHeroTopPadding),
    formHeroBottomPadding: normalizeHeroPadding(raw.formHeroBottomPadding),
    formHeroTitleSize: normalizeHeroTitleSize(raw.formHeroTitleSize),
    whyTitle: legacySectionContent.whyTitle,
    whyItems: legacySectionContent.whyItems,
    faqTitle: legacySectionContent.faqTitle,
    faqItems: legacySectionContent.faqItems,
    flowContents: normalizeCrmAdvancedFlowContents(raw.flowContents, legacySectionContent),
    sharePage: normalizeCrmSharePageSettings(raw.sharePage),
  }
}

export const getCrmAdvancedBackgroundSlot = (key: string) =>
  CRM_ADVANCED_BACKGROUND_SLOTS.find((slot) => slot.key === key) || null

/** 解析高级版背景 URL；未设置或素材为空时返回 ''（前台回退到模板背景）。 */
export const resolveCrmAdvancedBackgroundUrl = (settings: CrmAdvancedSiteSettings): string => {
  if (settings.backgroundKey === CRM_ADVANCED_CUSTOM_BACKGROUND_KEY) {
    return settings.customBackgroundUrl
  }
  return getCrmAdvancedBackgroundSlot(settings.backgroundKey)?.imageUrl || ''
}

/** 渲染 FAQ 答案：将 {email} 占位符替换为站点客服邮箱；未配置时隐藏占位（不暴露平台域名）。 */
export const renderCrmAdvancedFaqAnswer = (answer: string, contactEmail: string): string => {
  const email = String(contactEmail || '').trim()
  const rendered = String(answer ?? '').replaceAll(CRM_ADVANCED_FAQ_EMAIL_TOKEN, email)
  if (email) return rendered
  // 没有客服邮箱时移除“ at {email}”片段，避免出现空地址
  return rendered.replace(/\s+at\s*$/i, '').replace(/at\s+\./i, '.')
}

/** 判断该流程版本是否为高级版 */
export const isCrmAdvancedFlowVersion = (value: unknown): boolean =>
  String(value ?? '') === 'advanced'

/** 解析平台展示顺序；未配置时返回默认顺序。 */
export const resolveCrmAdvancedPlatformOrder = (
  settings: CrmAdvancedSiteSettings,
): CrmOrderMatchPlatform[] =>
  Array.isArray(settings?.platformOrder) && settings.platformOrder.length
    ? normalizePlatformOrder(settings.platformOrder)
    : [...CRM_ADVANCED_DEFAULT_PLATFORM_ORDER]
